import { Injectable } from '@angular/core';
import { Configuration } from '../configuration';
import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';

@Injectable()
export class MatchingAdvertService extends BaseService {

    constructor(http: GlobalHttpClient, private configuration: Configuration) {
        super(http);
    }

    search(id: number) {
        return this.http.get(`adverts/mymatches/${id}`);
    }

    markRead(id: number) {
        return this.http.get(`adverts/markRead/${id}`);
    }

    remove(id: number) {
        return this.http.get(`adverts/remove/${id}`);
    }

    getBanner(subscriber: boolean) {
        return this.http.get(`adverts/getBanner/${subscriber}`);
    }

    showConsultationButton(supplierId: number) {
        return this.http.get(`adverts/showConsultationButton/${supplierId}`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/matching.advert.service.ts